import { Card, CardBody, Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import { formatCurrency } from "../utils/formatUtils";
import { connect } from "react-redux";

const ValueSponsorMetric = ({sponsor, loading, selectedCurrency}) => {
  const logo = sponsor.logoUrl;
  const metric = "Sponsor";
  const value = formatCurrency(sponsor.value, selectedCurrency);
  const growth = sponsor.growth;
  const growthClass = parseFloat(growth) >= 0 ? 'positive' : 'negative';

  return (
    <Link to={`/value-divided?partner=${sponsor.name}`}>
      <Card className="value-sponsor-metric">
        <CardBody>
          <div className="metric-content">
            <div className="sponsor-info">
              { loading ? <Spinner color="primary" /> : 
                <img src={logo} alt={sponsor} className="sponsor-logo" />
              }
              <div>
                <p className="sponsor-name">
                  { sponsor !== undefined && sponsor?.name}
                </p>
                <p className="sponsor-metric">{metric}</p>
              </div>
            </div>
            <div className="metric-values">
              { loading ? <Spinner color="primary" /> :
                <>
                  <p className="metric-value">{value}</p>
                  <p className={`metric-growth ${growthClass}`}>{Math.round(growth * 100)}%</p>
                </>
              }
            </div>
          </div>
        </CardBody>
      </Card>
    </Link>
  );
}

const mapStateToProps = (state) => ({
  selectedCurrency: state.currency.selectedCurrency,
});

export default connect(mapStateToProps)(ValueSponsorMetric);
